import { Component, OnInit, OnDestroy, ViewChild, Input, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
//import 'ag-grid-enterprise/main';
import { LoopBackFilter, Activity } from '../../../sdk/models';
import { ActivityApi } from '../../../sdk/services/custom';
import { FormBuilder, FormGroup } from "@angular/forms";
import { FormlyFieldConfig} from 'ng-formly';
import { activityFields } from '../../../formfields';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'previousactivities-widget',
    templateUrl: './previousactivities.component.html',
    providers: [ActivityApi],
    styleUrls: ['./previousactivities.component.scss']

})

export class PreviousActivitiesWidgetComponent implements OnInit, OnDestroy {

    @Input() entityrecordid: any;
    @Input() entityid: any;

    showCardWrapper = true;
    formActivity: FormGroup;
    currentuser;
    subscriptions: any = [];
    activityFields: Array<FormlyFieldConfig> = [];
    activity: Activity = new Activity();
    previousactivities = [];
    notifyOptions = PlatformApp.getNotificationOptions();
    @Input() disableCardWrapper: boolean;
    @ViewChild('childModal') public childModal: ModalDirective;

    public showChildModal(): void {
        this.childModal.show();
    }

    public hideChildModal(): void {
        if (this.formActivity && this.formActivity['subscriptions'])
            this.formActivity['subscriptions'].forEach(s => { s.unsubscribe(); });
        if (this.formActivity)
            this.formActivity = this.fb.group({});
        this.childModal.hide();
    }

    constructor(private _ActivityApi: ActivityApi,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private fb: FormBuilder, private _LoopBackAuth: LoopBackAuth) {

    }

    ngOnInit(): void {
        if (this.disableCardWrapper) {
            this.showCardWrapper = false;
        }
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.getPreviousActivityData();
        this.activityFields = activityFields;
        this.activity.entityId = this.entityid;
        this.activity.entityrecordId = this.entityrecordid;

        this.activity.createdby = this.currentuser.id;
        this.activity.lastupdatedby = this.currentuser.id;
        this.activity.appId = this.currentuser.appId;
        this.activity.type = "activity";
        this.activity.status = "open";

        this.formActivity = this.fb.group({});

    }



    public getPreviousActivityData() {
        let filter: LoopBackFilter = {
            "where": {
                "appId": this.currentuser.appId,
                "ActivityDate": { lte: Date.now() }
            },
            "order": 'ActivityDate DESC',
            "limit": 5
        };
        if (this.entityid) {
            filter.where.entityId = this.entityid;
        }
        if (this.entityrecordid) {
            filter.where.entityrecordId = this.entityrecordid;
        }
        filter["data"] = true;
        this.subscriptions.push(this._ActivityApi.find(filter)
            .subscribe((results) => {
                if (results) {
                    this.previousactivities = results;
                }
            }));
    }

    private patchOrCreateActivity(activity): void {

        this.subscriptions.push(this._ActivityApi.patchOrCreate(this.activity)
            .subscribe((newactivity) => {
                this.getPreviousActivityData();
            }));
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    private notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/previousactivities/previousactivities.component.ts